import {isNull, isUndefined, omitBy, pipe} from '@yandex-delivery/utils'

import type {Contact, OrderFormState} from '../../../types'
import {getIndex} from './get-index'

export function toRoutePoints(formState: OrderFormState) {
  const returnPoint = formState.route?.return?.address

  let routePoints = formState.route
    ? Object.keys(formState.route).flatMap((key, keyIndex) => {
        const index = getIndex(key, keyIndex, Object.keys(formState.route).length)
        const {address} = formState.route[key] || {}

        if (!address) {
          return []
        }

        const mappedAddress = {
          address: toAddress(address),
          point_id: index,
          contact:
            key === 'return'
              ? {
                  phone: returnPoint.phone,
                  route_index: index,
                  name: formState.contacts[0].name,
                }
              : {...formState.contacts?.find((contact: Contact) => contact.pointId === key), route_index: index},
          type: key === 'source' || key === 'return' ? key : 'destination',
          visit_order: index + 1,
          skip_confirmation: key === 'return' ? formState.skip_confirmation : null,
        }

        return pipe(mappedAddress, omitBy(isNull), omitBy(isUndefined))
      })
    : []

  // фильтр - потому что в data может приехать return с пустым адресом,
  // сорт - потому что ручке принятия заказа принципиален порядок точек в route_points
  routePoints = routePoints
    .filter(point => !!point.address?.fullname)
    ?.sort((point1, point2) => point1.point_id - point2.point_id)

  return routePoints
}

const toAddress = address => ({
  fullname: address.title,
  shortname: address.title,
  coordinates: address.coordinates,
  uri: address.uri,
  country: address.country,
  city: address.city,
  building: address.building,
  street: address.street,
  apartment: address.apartment,
  entrance: address.entrance,
  floor: address.floor ? Number(address.floor) : undefined,
  code: address.code,
  comment: address.comment,
})
